import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { Helmet } from 'react-helmet';
import SendVox from '../components/buttons/send';
import Checkbox from '../components/checkbox';
import ga from '../utils/ga-tracker';
import { CREATE_VOX } from '../utils/graph-api';
import { t, tspan } from '../utils/i18n';
import { DirectUpload } from '@rails/activestorage';
import { ColoredFooter } from './mic-check';
import {get} from 'lodash/fp';
import { VALID_EMAIL_REGEX, VALID_NAME_REGEX } from '../components/ValidationPatterns';
import PhoneNumber from "../components/PhoneNumber";
import Input from "./Input";
import  TagsSelector   from '../components/tags-dropDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfoSquare, faStop} from "@fortawesome/pro-solid-svg-icons";
import {ToolTip, ToolTipText} from "../styles/styled/toolTip";
import HostedTags from './tags/hosted-tags';
import { sendButton } from '../utils/alt-tags';


const queryString = require('query-string');

const ContactContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;

    .checkbox {
        width: 50%;
        font-size: 0.875rem;

        &-label {
            color: rgb(68, 68, 68);
        }
    }

    .contact-form {
        margin-top: ${props => props.pluginMode ? '2rem' : '1rem'};
        display: flex;
        flex-direction: column;
        width: 100%;

        .row {
        margin-left: 0;
        margin-right: 0;
        padding: 0rem 2.2rem;
        }

        ${props => props.settings && props.settings.mode === 'sample' && css`border-color: 1px whitesmoke;`}

        .input-line {
            width: 100%;
            padding: 0.25rem 0rem;

            text-align: justify;
            font-size: 0.875rem;
            ${breakpoint('xs', 'sm')`
                font-size: 0.75rem;
            `}

            display: flex;
            flex-wrap: nowrap;

            span {
                flex: 1;
            }

            input {
                flex: 1;
                text-align: left;
            }
        }
    }
    .tag-selector {
        padding-right: 0rem !important;
    }

    .buttons {
        padding-bottom: 0rem;
    }

    .small-print {
        font-size: 0.5rem;
        line-height: 1rem;

        span {
            display: inline-block;
            max-width: 90%;
        }
    }

    // button {
    //     height: 2.4rem;
    //     width: 35.5%;
    //     ${props => props.pluginMode && css`
    //         width: 75%;
    //     `}
    //
    //     font-size: 0.8rem;
    //     border-radius: 0.18rem;
    //     border: none;
    //     outline: none;
    //
    //     font-weight: 700;
    //     color: white;
    // }
`;

const MailingCheck = styled(Checkbox)`
    font-family: Titillium Web;
    align-self: flex-start;
    font-size: 1rem;
    display: -webkit-inline-box;
    label{
      position: relative;
      top: 7px;
      font-size: 12px;
      line-height: 13px;
      font-style: normal;
      font-weight: normal;
      color: #2E394F;
    }
`;

export const FormGroup = styled.div`
      margin-bottom : 0.8rem !important;
      ${props => props.pluginMode && css`
        position: relative;
      `}
      min-height: 115px;
      display:${props => props.isPublicHosted ? 'flex': ''} 
      margin-left: ${props => props.isPublicHosted && (props.tagOptions && props.tagOptions.length !== 0)  && '2rem' };

      p {
        &.resend {
          margin-bottom: 20px;
          font-size: .75rem;
          &.errorMessage{
            color:red;
          }   
        }
          i {
            &.valid{
              color: #409D57;
              margin-right: 5px;
            }
          }

          span{
            &.email-sent-span{
              color: #409D57;
            }
          }

          small {
            font-size: 0.625rem;

            a {
              &.underline {
                color: $telbee_secondarygrey;
                font-weight: 700;
              }
            }
            
          }

        }

        a {
          &.add-number {
            color: $telbee_secondarygrey;
          }
        }
`;

const InputComponent = styled.div`
  flex: ${props => props.options && props.isPublicHosted && '1' };
  width: ${props => !props.options && props.isPublicHosted && '85%' }
  margin: ${props =>  !props.options && props.isPublicHosted && 'auto'};
  width: -webkit-fill-available;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
`;
const DetailsPrivacyText = styled.span`
  font-family: Titillium Web;
  font-size: 10px;
  line-height: 13px;
  font-size: 12px;
  line-height: 10px;
  font-style: normal;
  font-weight: normal;
  color: #2E394F;
  a{
  color: ${(props) => props.color ? props.color : '#2E394F' };
  font-weight: 600;
  }
`;
export const CustomPhoneNumber = styled.div`
  .invalid-feedback {
    display: block !important;
  }
`;
const InfoButton = styled.button`
  background: #FFFFFF;
  align-self: flex-end;
  margin: 0;
  padding-left: 0;
  border: none;
`;

const DetailsSaved = styled.p`
  font-family: Titillium Web;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  span{
  color: red;
  cursor: pointer;
  }
`;
 const ErrorToolTip = styled(ToolTip)`
  width: 100%;
  &:hover {
      cursor: ${(props) => (props.showToolTip  ? 'pointer' : 'default')};
  }
  &:hover .tooltiptext {
        visibility:${(props) => (props.showToolTip ? 'visible' : 'hidden')};
  }
`;

const ErrorText = styled(ToolTipText)`
  bottom: 48px;
  padding: 4px !important;
  width: 190px !important;
  margin-left: 2rem !important;
  z-index: 9;
  font-family: Titillium Web;
  font-style: normal;
        visibility:${(props) => (props.showToolTip ? 'visible' : 'hidden')};
`;

export const Asterisk = styled.span`
  position: relative;
  bottom:  ${props => props.btmDis && '6px' };
  left: 5px;
  font-size: 15px;
  height: 8px;
  margin-bottom: ${(props) =>  props.isPublicHosted ? '6px' : '2px'}
  visibility: ${(props) =>  props.visible ? 'visible' : 'hidden'}
  width: ${(props) =>  props.isPublicHosted ? '88%' : '1%'}
`;

class ContactDetails extends Component {
    constructor(props){
      super(props);
      this.handleInfoStatusChanged = this.handleInfoStatusChanged.bind(this);
      this.infoStatusChanged = this.infoStatusChanged.bind(this);
    }
    state = {
        fName: '',
        email: '',
        phone: '',
        phoneDigits: '',
        consent: false,
        detailsSaved: false,
        processing: false,
        channelToken: '-1',
        createdBy: 'Contact',
        createdById: -1,
        signedId: '',
        sourceType: '',
        voxContext: '',
        formErrors: '',
        selectedOption: null,
        tagIds: null,
        tagThankYouText: null,
        infoState: false,
    }

    async componentDidMount() {
      const {query} = queryString.parseUrl(window.location.href);
      if (localStorage){
          const prevConsent = localStorage.getItem('consent');
          this.setState({consent : !!prevConsent, detailsSaved : prevConsent});
      }
      if(query && query.reply === 'reply'){
        this.setState({
          sourceType: query.reply,
          createdBy: query.createdBy,
          createdById: query.createdById,
          email: query.contactEmail,
          phone: query.contactMobile,
          fName: query.contactName,
        });
      }
      if (localStorage.getItem('consent')){

          this.setState({fName: localStorage.getItem('fName') !==null ?  localStorage.getItem('fName') : '',
              email: localStorage.getItem('email') !==null ?  localStorage.getItem('email') : ''
          });
          if (localStorage.getItem('phone') != null){
              this.setState({phone: localStorage.getItem('phone') !==null ? localStorage.getItem('phone') : ''});
          }
      }
    }

    handleErrors = async (submit = false, name) => {
        await this.getSelectedTagsData();
        const {fName, email, phone, phoneDigits, tagIds, selectedOption, formErrors } = this.state;
        const { settings: { common }, tagOptions, isPublicHosted } = this.props;
        var emailDomain = email.split('@')[1];
        const errors = {
            fName: (formErrors.fName && name === 'fName') ? '' : formErrors.fName,
            phoneDigits: (formErrors.phoneDigits && name === 'phoneDigits') ? '' : formErrors.phoneDigits,
            email: (formErrors.email && name === 'email') ? '' : formErrors.email,
            tags: (formErrors.tags && name === 'tags') ? '' : formErrors.tags,
        };
        if (!fName && submit) {
            errors.fName = (isPublicHosted || common.nameRequired) ? 'Name is required' : "";
        } else if (fName && fName.length < 2) {
            errors.fName = `Name should be at least ${2} characters long`;
        }
        if (!phoneDigits && submit) {
            errors.phoneDigits = common.phoneRequired ? 'Phone is required' : '';
        } else if (phoneDigits && phoneDigits.match(/\d/g).length < 9) {
            errors.phoneDigits = `Phone should be at least ${9} characters long`;
        }
        if ((!email && submit) || (!email && isPublicHosted)) {
            if (isPublicHosted) {
                if (tagIds.length > 0) {
                    tagIds.map((item, index) => {
                        let myVal = tagOptions.find(option => option.id === item);
                        if (myVal.emailRequired) {
                            errors.email = myVal.domainToVerify === null ? 'Please enter your email here. We will send you a verification email to confirm your public ' +
                                'figure status before applying this tag to your blessing.' :
                                `Please type your email ending in ${myVal.domainToVerify} below - we will send you a verification email before applying this tag to your blessing.`;
                        }
                    })
                } else if(common.emailRequired) {
                    errors.email = 'Email is required';
                } else {
                    errors.email = '';
                }
            } else {
                errors.email = common.emailRequired ? 'Email is required' : "";
            }
        } else if (email && !VALID_EMAIL_REGEX.test(email)) {
            errors.email = 'Please enter a valid email address';
        }
        else if (VALID_EMAIL_REGEX.test(email)) {
            if (tagIds.length > 0) {
                tagIds.map((item,index)=>{
                    let myVal = tagOptions.find(option => option.id === item);
                    if (myVal.domainToVerify && emailDomain !== myVal.domainToVerify){
                        errors.email = `Please type your email ending in ${myVal.domainToVerify} below - we will send you a verification email before applying this tag to your blessing.`;
                    }
                })
            } else {
                errors.email = '';
            }
        }
        if (!selectedOption && submit && isPublicHosted && tagOptions.length > 0){
            errors.tags = 'Please select 1 or 2 tags';
        }
        await this.setState({formErrors: errors});
    }

    onInputChange = ({ target }) => {
        this.setState({ [target.name]: (target.type === 'checkbox' ? target.checked : target.value) }, () => {
             if (target.type === 'checkbox') {
                this.saveDetails()
             }
            this.handleErrors(false, target.name)
        });

    };
    saveDetails = () => {
        const { consent, fName , phone, email, phoneDigits } = this.state;
        localStorage.setItem('consent', consent);
        if (consent){
            if ((fName && fName.length >= 2)){
                localStorage.setItem('fName',fName);
            }
            if (VALID_EMAIL_REGEX.test(email)){
                localStorage.setItem('email',email);
            }
            if (phoneDigits && phoneDigits.match(/\d/g).length >= 9 ){
                localStorage.setItem('phone',phone);
            }
        }else {
            localStorage.removeItem("fName");
            localStorage.removeItem("email");
            localStorage.removeItem("phone");
            localStorage.removeItem("consent");
        }
    };
    removeDetails = () => {
        localStorage.removeItem("fName");
        localStorage.removeItem("email");
        localStorage.removeItem("phone");
        localStorage.removeItem("consent");
        this.setState({
            fName: '',
            email: '',
            phone: '',
            consent: false,
            detailsSaved: false,
        })
    };

     handlePhoneNumberChange = (value, data, event) => {
        const codeLength = data.countryCode === "us" ? 1 : data.dialCode.length;
        this.setState({phone: value});
        this.setState({ phoneDigits: value.replace(/[^0-9]+/g,'').slice(codeLength)},
            () => this.handleErrors(false, 'phoneDigits'));
    };

    handleSelectChange = async (selectedOption) => {
        if (selectedOption && selectedOption.length <=2 ){
            await this.setState(
                { selectedOption }
            );
        }else   if (selectedOption === null){
            await this.setState(
                { selectedOption }
            );
        }
        this.handleErrors(false, 'tags');
    };

    getSelectedTagsData() {
        const { selectedOption } = this.state;
        let myIds = [];
        let thankYouText = [];
        selectedOption && selectedOption.map((item,index) => {
            myIds.push(item.id);
            thankYouText.push(item.thankyouText);
        });
        this.setState({tagIds: myIds, tagThankYouText: thankYouText});
    }
    async onSubmit() {
        const {isPublicHosted, onSwitch, client, blob, duration} = this.props;
        isPublicHosted && await this.getSelectedTagsData();
        await this.handleErrors(true);
        const {formErrors, tagThankYouText} = this.state;
        if (ga.initialized)
            ga.f.event({
                category: 'interaction',
                action: 'submit'
            });
        if (!formErrors.fName && !formErrors.email && !formErrors.phoneDigits && !formErrors.tags) {
            const {settings: {recorder: recorderSettings}} = this.props;

            await this.setState({processing: true});

            var file = new File([blob], new Date());
            const upload = new DirectUpload(file, `${process.env.REACT_APP_API_URL}/rails/active_storage/direct_uploads`, this);
            upload.create((error, blob) => {
                if (error) {
                    alert(error);
                } else {
                    const {fName, email, phone, channelToken, createdBy, createdById, tagIds} = this.state;
                    (async () => {
                        const {data} = await client.mutate({
                            mutation: CREATE_VOX,
                            variables: {
                                contentType: recorderSettings.contentType,
                                recordingUrl: blob.signed_id,
                                firstName: fName,
                                email: email,
                                mobile: phone,
                                channelToken: channelToken,
                                createdBy: createdBy,
                                createdById: parseInt(createdById, 10),
                                length: Math.floor(duration),
                                tagIds: tagIds,
                            }
                        });

                const { id, token } = data.createVox.vox
                this.setState({ processing: false });
                window.parent.postMessage("NHSEvent", "*")
                onSwitch('complete', { id, tagThankYouText, token });

                    })();

                }
            });
        }
    }

    infoStatusChanged(){
      this.setState({ infoState: true });
    }
    handleInfoStatusChanged(){
      this.setState({ infoState: false });
    }

    render() {
      const { settings: { common }, pluginMode, isPublicHosted, tagOptions } = this.props;
      const {
        fName, email, phone, consent, processing, sourceType, formErrors, phoneDigits,  selectedOption, detailsSaved,
        infoState,
      } = this.state;
      return (
        <ContactContainer pluginMode={pluginMode}>
          {isPublicHosted && <Helmet>
          <script type="text/javascript" src="https://platform-api.sharethis.com/js/sharethis.js#property=5e87102b5858820019858aa5&product=inline-share-buttons" async="async" />
          </Helmet>}

            {infoState ?
                <HostedTags
                    options={tagOptions}
                    handleInfoStatusChanged={() => this.handleInfoStatusChanged()}
                /> :
                <>
                <div className="content">
            {/* Contact form */}
            <div className="plugin-header">
                <div className="title"
                    style={{
                        fontStyle: 'normal',
                        fontFamily: 'Titillium Web',
                        fontWeight: 'bold',
                        fontSize: '16px',
                        lineHeight: '24px',
                        color:'#27364E',
                        verticalAlign: 'middle',
                        wordBreak:'break-word',
                        whiteSpace: 'pre-wrap',
                    }}>
                    {tspan('submitTitle', { break: <br/> })}
                </div>
            </div>
              {isPublicHosted &&
              <div className="sub-title" style={{
                  fontFamily:'Titillium Web',
                  marginTop:`${pluginMode ? "10px" : "0"}`,
              }}>
                  {tspan('submitSubTitle', { break : <br/>})}
              </div>
              }
            {sourceType !== 'reply'
              ? (
                <div className="contact-form">
                    <FormGroup isPublicHosted={isPublicHosted} options={tagOptions} pluginMode={pluginMode}>
                    <InputComponent isPublicHosted={isPublicHosted} options={tagOptions}>
                        {common.nameEnabled &&
                        <div className="row">
                            <div className="col-12" style={{lineHeight:'normal'}}>
                                <Input
                                    type="text"
                                    name="fName"
                                    maxLength="60"
                                    value={fName}
                                    disabled={processing}
                                    onChange={this.onInputChange}
                                    placeholder={t('namePlaceholder', null, false)[0] ? t('namePlaceholder', null, false)[0] : 'Your name'}
                                    className="form-control"
                                    style={{ textTransform: 'capitalize' }}
                                    error={get('fName', formErrors)}
                                    id="fName"
                                    common={common}
                                    visible={common.nameRequired}
                                />
                            </div>
                        </div>}
                        {isPublicHosted ? (<ErrorToolTip showToolTip={get('email', formErrors)}>
                            <ErrorText className="tooltiptext" showToolTip={get('email', formErrors)}>{get('email', formErrors)}</ErrorText>
                            <div className="row">
                                    <div className="col-12">
                                        <Input
                                            type="email"
                                            name="email"
                                            maxLength="40"
                                            value={email}
                                            disabled={processing}
                                            onChange={this.onInputChange}
                                            placeholder={t('emailPlaceholder', null, false)[0] ? t('emailPlaceholder', null, false)[0] : 'Your e-mail'}
                                            error={get('email', formErrors)}
                                            id="email"
                                            common={common}
                                            isPublicHosted={isPublicHosted}
                                            visible={common.emailRequired}
                                        />
                                    </div>
                                </div>
                        </ErrorToolTip>) : (
                            common.emailEnabled &&
                            <div className="row">
                                <div className="col-12" style={{lineHeight:'normal'}}>
                                    <Input
                                        type="email"
                                        name="email"
                                        maxLength="40"
                                        value={email}
                                        disabled={processing}
                                        onChange={this.onInputChange}
                                        placeholder={t('emailPlaceholder', null, false)[0] ? t('emailPlaceholder', null, false)[0] : 'Your e-mail'}
                                        error={get('email', formErrors)}
                                        id="email"
                                        common={common}
                                        visible={common.emailRequired}
                                        />
                                </div>
                            </div>
                            )}
                        {isPublicHosted && (tagOptions && tagOptions.length !== 0 ) ?
                            <ErrorToolTip showToolTip={get('tags', formErrors)}>
                                <ErrorText className="tooltiptext" showToolTip={get('tags', formErrors)} style={{bottom: '39px'}}>{get('tags', formErrors)}</ErrorText>
                                <div className={`row ${isPublicHosted && (tagOptions && tagOptions.length !== 0 ) && 'tag-selector' }`}>
                                    <Asterisk isPublicHosted={isPublicHosted} visible={false}>*</Asterisk>
                                    <div className={`col-12 ${isPublicHosted && (tagOptions && tagOptions.length !== 0 ) && 'd-flex' }`}>
                                            <React.Fragment>
                                                <TagsSelector
                                                    options={tagOptions}
                                                    handleSelectChange={this.handleSelectChange}
                                                    selectedOption={selectedOption}
                                                    error={get('tags', formErrors)}
                                                />
                                                {(isPublicHosted && (tagOptions && tagOptions.length !== 0 )) && (
                                                    <InfoButton style={{background:'#FFFFFF',alignSelf:'center'}} className="col-1" onClick={() => this.infoStatusChanged() }>
                                                        <FontAwesomeIcon style={{color: '#005EB8',height:'17px',width:'16px',marginTop:'4px'}} icon={faInfoSquare}/>
                                                    </InfoButton>
                                                )}
                                            </React.Fragment>
                                            </div>
                                            </div>
                                            </ErrorToolTip>
                                            :
                            (common.phoneEnabled && <div className='row'>
                                <div className='col-12' style={{lineHeight:'normal'}}>
                                    <CustomPhoneNumber >
                                        <PhoneNumber
                                            id="phone"
                                            onChange={this.handlePhoneNumberChange}
                                            country={get('phoneDigits', formErrors)}
                                            name="phone"
                                            maxLength="14"
                                            className="form-control"
                                            value={phone}
                                            disabled={processing}
                                            placeholder={t('phonePlaceholder', null, false)[0] ? t('phonePlaceholder', null, false)[0] : 'Your phone number'}
                                            common={common}
                                            phoneDigits={phoneDigits}
                                            id="phone"
                                            countryCode={common.countryCode}/>
                                    </CustomPhoneNumber>
                                </div>
                            </div>)
                        }

                    </InputComponent>
                </FormGroup>
                    <div>
                      {detailsSaved ? <DetailsSaved>Your details are saved in this browser <span onClick={this.removeDetails}>- remove</span></DetailsSaved> :
                  <MailingCheck
                    name="consent"
                    label={t(common.isPublicHosted ? 'contact-mailing-public-hosted' : 'contact-mailing')}
                    checked={consent}
                    disabled={processing}
                    primaryColor={common.primaryColor}
                    onChange={this.onInputChange}
                  />
                      }
                      {common.privacyLinkRequired &&
                      (<div style={{marginTop: '4px', padding: `0 ${pluginMode ? '15px' : '2.2rem'}`}}>
                        <DetailsPrivacyText
                            color={common.buttonColor}
                        >Our <a href={common.isPublicHosted ? "https://blessourheroes.webflow.io/legal/privacy-policy" :
                            common.privacyLink ? common.privacyLink.includes('http' || 'https') ?
                                common.privacyLink : `https://${common.privacyLink}` : "https://www.telbee.io/privacy/"}
                                rel="noopener noreferrer" target="_blank">Privacy Policy</a> explains how we use and protect your personal information. Please read it before pressing send.</DetailsPrivacyText>
                      </div>
                      )}
                </div>
                </div>
              ) : null}
          </div>
          <ColoredFooter className="buttons" style={{zIndex: '0'}} requiredShadow={common.requiredShadow} hideGreyBar={common.hideGreyBar}>
            {/* Submit button */}
            <SendVox common={common} processing={processing} onClick={() => this.onSubmit()}
                     micPermission={true} title={sendButton}/>
          </ColoredFooter>
                </>
            }

        </ContactContainer>
      );
    }
}

export default withApollo(ContactDetails);
